import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useRouter } from "@tanstack/react-router"
import axios from "axios"
import { useTrackEvent } from "lib/mixpanel"
import { TRACKING_EVENTS } from "lopermut"
import { CampaignResponseDataSchema, UpdateCampaignSchema } from "schema"
import { z } from "zod"
import { getCampaignQueryKey } from "../lib/campaignQuery"
import { getCampaignsQueryKey } from "../lib/campaignsQuery"

type Props = {
  onSuccess?: () => void
}

export const useUpdateCampaignMutation = (id: string, { onSuccess }: Props = {}) => {
  const queryClient = useQueryClient()
  const router = useRouter()
  const trackEvent = useTrackEvent()

  return useMutation({
    mutationFn: async (data: z.input<typeof UpdateCampaignSchema>) => {
      const response = await axios.put<{ data: z.infer<typeof CampaignResponseDataSchema> }>(
        `/campaigns/${id}`,
        data,
      )

      trackEvent(TRACKING_EVENTS.CAMPAIGN_UPDATED, {
        campaignId: response.data.data.id,
        ...data,
      })

      return response.data.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(id) })
      queryClient.invalidateQueries({ queryKey: getCampaignsQueryKey() })
      router.invalidate({ filter: (m) => m.routeId === "/_base/_auth/campaigns/$id" })
      onSuccess?.()
    },
  })
}
